import { ButtonColor, EmptyState } from "@quortex/front-common"
import type { FC } from "react"
import illustrationNoResults from "src/App/play/images/illustration-no-results.svg"

type Props = {
  onClearFilters: () => void
}

const EmptySearchResult: FC<Props> = ({ onClearFilters }) => (
  <EmptyState
    description="No results"
    img={illustrationNoResults}
    primaryButtonProp={{
      color: ButtonColor.SECONDARY,
      label: "Clear all filters",
      onClick: () => onClearFilters(),
      type: "button"
    }}
  />
)

export default EmptySearchResult
